var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { personalDataApi } from "apis/eduidPersonalData";
import { useAppDispatch, useAppSelector } from "eduid-hooks";
import { AVAILABLE_LANGUAGES, LOCALIZED_MESSAGES } from "globals";
import { useCallback, useEffect } from "react";
import { Field, Form as FinalForm } from "react-final-form";
import { FormattedMessage } from "react-intl";
import { updateIntl } from "slices/Internationalisation";
export function LanguagePreference() {
    const dispatch = useAppDispatch();
    const personal_data = useAppSelector((state) => state.personal_data.response);
    const locale = useAppSelector((state) => state.intl.locale);
    const isLoaded = useAppSelector((state) => state.config.is_app_loaded);
    const messages = LOCALIZED_MESSAGES;
    // Make an ordered list of languages to be presented as radio buttons
    const _languages = AVAILABLE_LANGUAGES || {};
    const language_list = Object.entries(_languages);
    const [postUserLanguage] = personalDataApi.usePostUserLanguageMutation();
    const postLanguage = useCallback((postData) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const response = yield postUserLanguage(postData);
        if ("data" in response) {
            if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.payload.language) {
                dispatch(updateIntl({
                    locale: response.data.payload.language,
                    messages: messages[response.data.payload.language],
                }));
            }
        }
    }), [postUserLanguage, dispatch, messages]);
    const formSubmit = useCallback((values) => __awaiter(this, void 0, void 0, function* () {
        // Send to backend as parameter: display name only for verified users. default display name is the combination of given_name and surname
        const postData = {
            language: values.language,
        };
        postLanguage(postData);
    }), [postLanguage]);
    useEffect(() => {
        if (isLoaded && (personal_data === null || personal_data === void 0 ? void 0 : personal_data.language) === undefined) {
            postLanguage({ language: locale });
        }
    }, [isLoaded, locale, personal_data === null || personal_data === void 0 ? void 0 : personal_data.language, postLanguage]);
    return (_jsxs("article", { id: "language", children: [_jsx("h2", { children: _jsx(FormattedMessage, { id: "common.language", description: "pd main title", defaultMessage: "Language" }) }), _jsx("p", { children: _jsx(FormattedMessage, { id: "language.description", description: "pd long description", defaultMessage: "You can choose your preferred language. The effect will be visible in the interface when you are logged in and in any emails sent to you." }) }), _jsx(FinalForm, { initialValues: { language: personal_data === null || personal_data === void 0 ? void 0 : personal_data.language }, onSubmit: formSubmit, render: (formProps) => {
                    return (_jsx("form", { id: "personaldata-view-form", onChange: formProps.handleSubmit, children: _jsx("fieldset", { children: _jsxs("article", { children: [_jsx("legend", { className: "require", children: _jsx(FormattedMessage, { id: "common.language", defaultMessage: "Language", description: "Language" }) }), _jsx("div", { className: "radio-input-container", children: language_list.map((option) => {
                                            const [key, value] = option;
                                            return (_jsxs("label", { htmlFor: value, children: [_jsx(Field, { name: "language", component: "input", type: "radio", id: value, value: key }), _jsx("span", { children: value })] }, key));
                                        }) })] }) }) }));
                } })] }));
}
